import * as React from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
    // Initialize to false to match SSR and prevent hydration mismatch
    const [isMobile, setIsMobile] = React.useState<boolean>(false)
    const [mounted, setMounted] = React.useState(false)

    React.useEffect(() => {
        setMounted(true)
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
        const onChange = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
        }
        mql.addEventListener('change', onChange)
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
        return () => mql.removeEventListener('change', onChange)
    }, [])

    // Return false during SSR to match initial server render
    return mounted ? isMobile : false
}
